<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="wrapper">
    <span class="w-title">{{ adding?'新建待办事项':(editing ? "修改待办事项" : "待办详情信息") }}</span>
    <v-divider class="my-3"/>
    <v-container fluid grid-list-md class="xn-form pa-0">
      <div class="detail-btns">
        <v-btn color="info" flat @click="cancel">&lt; 返回待办事项列表</v-btn>
        <v-spacer></v-spacer>
        <v-btn v-if="item.taskId" color="error" flat outline @click="deleteThisItem">删除</v-btn>
      </div>
      <div class="form-panel">
        <div class="form-panel-head">基本信息</div>
        <div class="form-panel-body">
          <v-stepper v-model="stepper" vertical>
            <!--第一步-->
            <v-stepper-step :complete="stepper > 1" step="1">{{ progresses[0] }}</v-stepper-step>
            <v-stepper-content step="1">
              <v-layout wrap>
                <v-flex xs3 md2 class="d-flex mt-2">
                  <label :class="(editing||adding)&&!finishedStep1?'required':''">公司名称:</label>
                </v-flex>
                <v-flex xs9 md4>
                  <v-autocomplete
                    ref="form.companyId"
                    v-model="item.companyId"
                    no-data-text="无可用数据"
                    :items="companies"
                    :label="disableStepper1?'':'请选择公司'"
                    :rules="[rules.required]"
                    outline
                    solo
                    :disabled="disableStepper1"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs3 md2 class="d-flex mt-2"></v-flex>
                <v-flex xs9 md4></v-flex>
                <v-flex xs3 md2 class="d-flex mt-2">
                  <label :class="(editing||adding)&&!finishedStep1?'required':''">事项描述:</label>
                </v-flex>
                <v-flex xs9 md10>
                  <v-textarea
                    v-if="!disableStepper1"
                    ref="form.description"
                    v-model="item.description"
                    :label="disableStepper1?'':'待办事项描述'"
                    :rules="[rules.required]"
                    outline
                    solo
                  ></v-textarea>
                  <p v-if="disableStepper1" class="detail-area">{{ item.description }}</p>
                </v-flex>
                <v-flex xs3 md2 class="d-flex mt-2"></v-flex>
                <v-flex xs9 md10>
                  <v-btn v-if="!disableStepper1" style="margin-right: 10px !important;" outline @click="cancel">返回</v-btn>
                  <v-btn v-if="!disableStepper1" style="margin-right: 10px !important;" color="info" @click="saveStep1">保存</v-btn>
                  <v-btn
                    v-if="item.progress===progresses[0]&&disableStepper1"
                    color="success"
                    @click="deal"
                  >
                    下一步
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-stepper-content>
            <!--第一步-->

            <!--第二步-->
            <v-stepper-step :complete="stepper > 2" step="2">{{ progresses[1] }}</v-stepper-step>
            <v-stepper-content step="2">
              <v-layout wrap>
                <v-flex xs3 md2 class="d-flex mt-2">
                  <label :class="!disableStepper2?'required':''">委派:</label>
                </v-flex>
                <v-flex xs8 md5>
                  <v-autocomplete
                    ref="form.assignedUsername"
                    v-model="item.assignedUsername"
                    no-data-text="无可用数据"
                    :items="userNames"
                    label="请选择用户"
                    :rules="[rules.required]"
                    outline
                    solo
                    :disabled="disableStepper2"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs1 md5></v-flex>
                <v-flex xs3 md2 class="d-flex mt-2">
                  <label>备注说明:</label>
                </v-flex>
                <v-flex xs9 md10>
                  <v-textarea
                    v-if="!disableStepper2"
                    ref="form.createdNotes"
                    v-model="item.createdNotes"
                    :label="disableStepper2?'':'备注说明'"
                    outline
                    solo
                  ></v-textarea>
                  <p v-if="disableStepper2" class="detail-area">{{ item.createdNotes }}</p>
                </v-flex>

                <template v-if="!disableStepper2">
                  <v-flex xs3 md2 class="d-flex mt-2">
                    <label>是否填写快递单号:</label>
                  </v-flex>
                  <v-flex xs5 md6>
                    <v-radio-group v-model="showPhoneNumber" row @change="resetHeight">
                      <v-radio label="是" value="true"></v-radio>
                      <v-radio label="否" value="false"></v-radio>
                    </v-radio-group>
                  </v-flex>
                  <v-flex xs4 md4>
                    <v-dialog
                      v-if="item.progress!==progresses[0]&&item.shippingNumber"
                      v-model="dialog"
                      scrollable
                      max-width="614px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn color="info" outline v-on="on" @click="queryShipping">查询快递</v-btn>
                      </template>
                      <v-card>
                        <v-card-title>查询快递单号</v-card-title>
                        <v-divider></v-divider>
                        <v-card-text style="height: 400px;">
                          <v-timeline v-if="routes&&routes.length>0" dense clipped>
                            <v-timeline-item v-for="(route,index) in routes" :key="index" small color="grey">
                              <v-layout>
                                <v-flex xs3>
                                  <div class="caption">
                                    {{
                                      dateFormat(new Date(route.acceptTime), "YYYY-MM-DD HH:mm:ss")
                                    }}
                                  </div>
                                </v-flex>
                                <v-flex xs9>
                                  <div class="caption">{{ route.remark }}</div>
                                </v-flex>
                              </v-layout>
                            </v-timeline-item>
                          </v-timeline>
                          <span v-if="routes&&routes.length===0" style="line-height: 26px;">
                            暂未查到与您单号相关的物流信息，请稍候再尝试查询，有可能是：<br/>
                            1.快递单号不存在<br/>
                            2.快递尚未收取该快件<br/>
                            3.手机号填写错误<br/>
                          </span>
                        </v-card-text>
                      </v-card>
                    </v-dialog>
                  </v-flex>
                </template>

                <template v-if="showPhoneNumber==='true' ">
                  <v-flex xs3 md2 class="d-flex mt-2">
                    <label :class="!disableStepper2?'required':''">快递服务商:</label>
                  </v-flex>
                  <v-flex xs9 md4>
                    <v-autocomplete
                      ref="form.shippingProviderId"
                      v-model="item.shippingProviderId"
                      no-data-text="无可用数据"
                      :items="shippingProviders"
                      :label="disableStepper2?'':'请选择快递服务商'"
                      :rules="[rules.required]"
                      outline
                      solo
                      :disabled="disableStepper2"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs3 md2 class="d-flex mt-2">
                    <label :class="!disableStepper2?'required':''">快递单号:</label>
                  </v-flex>
                  <v-flex xs9 md4>
                    <v-text-field
                      ref="form.shippingNumber"
                      v-model="item.shippingNumber"
                      :label="disableStepper2?'':'快递单号'"
                      :rules="[rules.required]"
                      outline
                      solo
                      :disabled="disableStepper2"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs3 md2 class="d-flex mt-2">
                    <label>手机号:</label>
                  </v-flex>
                  <v-flex xs9 md4>
                    <v-text-field
                      ref="form.shippingPhoneNumber"
                      v-model="item.shippingPhoneNumber"
                      :label="disableStepper2?'':'收货方或发货方手机号或手机号末4位'"
                      :rules="[rules.number4orPhone]"
                      outline
                      solo
                      :disabled="disableStepper2"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs3 md2 class="d-flex mt-2">
                    <label :class="!disableStepper2?'required':''">快递内容:</label>
                  </v-flex>
                  <v-flex xs9 md4>
                    <v-text-field
                      ref="form.processingNotes"
                      v-model="item.processingNotes"
                      :label="disableStepper2?'':'请输入快递内容'"
                      :rules="[rules.required]"
                      outline
                      solo
                      :disabled="disableStepper2"
                    ></v-text-field>
                  </v-flex>
                </template>
                <v-flex xs1 md2 class="d-flex mt-2"></v-flex>
                <v-flex xs11 md10>
                  <v-btn v-if="!disableStepper2" style="margin-right: 10px !important;" outline @click="cancel">返回</v-btn>
                  <v-btn v-if="!disableStepper2" style="margin-right: 10px !important;" color="info" @click="saveStep2">保存</v-btn>
                  <v-btn v-if="item.progress!=='已完成'" style="margin-right:10px !important;" color="success" @click="saveStep3">完成</v-btn>
                  <v-dialog
                    v-if="item.progress===progresses[2]&&item.shippingNumber"
                    v-model="dialog"
                    scrollable
                    max-width="614px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn color="info" outline v-on="on" @click="queryShipping">查询快递</v-btn>
                    </template>
                    <v-card>
                      <v-card-title>查询快递单号</v-card-title>
                      <v-divider></v-divider>
                      <v-card-text style="height: 400px;">
                        <v-timeline v-if="routes&&routes.length>0" dense clipped>
                          <v-timeline-item v-for="(route,index) in routes" :key="index" small color="grey">
                            <v-layout>
                              <v-flex xs3>
                                <div class="caption">
                                  {{
                                    dateFormat(new Date(route.acceptTime), "YYYY-MM-DD HH:mm:ss")
                                  }}
                                </div>
                              </v-flex>
                              <v-flex xs9>
                                <div class="caption">{{ route.remark }}</div>
                              </v-flex>
                            </v-layout>
                          </v-timeline-item>
                        </v-timeline>
                        <span v-if="routes&&routes.length===0" style="line-height: 26px;">
                          暂未查到与您单号相关的物流信息，请稍候再尝试查询，有可能是：<br/>
                          1.快递单号不存在<br/>
                          2.快递尚未收取该快件<br/>
                          3.手机号填写错误<br/>
                        </span>
                      </v-card-text>
                    </v-card>
                  </v-dialog>
                </v-flex>
              </v-layout>
            </v-stepper-content>
            <!--第二步-->

            <!--第三步-->
            <v-stepper-step :complete="stepper > 3" step="3">{{ progresses[2] }}</v-stepper-step>
            <v-stepper-content step="3"></v-stepper-content>
            <!--第三步-->
          </v-stepper>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
  import axios from "../axios";
  import {mapState, mapActions} from "vuex";
  import {dateFormat} from "vue-filter-date-format";

  export default {
    name: "TaskForm",
    components: {},
    computed: {
      ...mapState({
        showLoading: state => state.showLoading,
        companies: state => state.miniCompanies,
        companiesMap: state => state.miniCompaniesMap,
      }),
      id() {
        return this.$route.params.taskId;
      },
      adding() {
        return !this.$route.params.taskId;
      },
      editing() {
        return (!!this.id) && this.$route.name === "task-form-edit"
      },
      detailing() {
        return (!!this.id) && this.$route.name === "task-form-detail"
      },
      disableStepper1() {
        let flag = false;
        if (this.adding) {
          flag = false;
        }
        if (this.detailing) {
          if (this.item.progress) {
            flag = true;//禁用按钮
          } else {
            flag = false;
          }
        }

        return flag || this.finishedStep1;
      },
      disableStepper2() {
        let flag = false;
        if (this.detailing || this.adding) {
          if (this.item.progress === this.progresses[2]) {
            flag = true;//禁用按钮
          } else {
            flag = false;
          }
        }

        return flag;
      },
    },

    data: () => {
      return {
        stepperIcon1: "fa-spinner",
        stepper: 1,
        rules: {
          required: value => !!value || "必填",
          length5: value => (!!value && value.length >= 5) || "长度至少为5",
          length8: value => (!!value && value.length >= 8) || "长度至少为8",
          // phoneNumber: value => {
          //   const pattern = /^1\d{10}$/;
          //   return pattern.test(value) || "请输入正确的手机号";
          // },
          number4orPhone: value => {
            const pattern1 = /^\d{4}$/;
            const pattern2 = /^1\d{10}$/;
            return (typeof value === "undefined" || value === null || value === "" || pattern1.test(value) || pattern2.test(value)) || "格式有误";
          },
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            // eslint-disable-next-line
            return (typeof value === "undefined" || value === null || value === "" || pattern.test(value)) || "请输入正确的邮箱";
          }
        },
        item: {},
        progresses: ["已创建", "正在处理", "已完成"],
        shippingProviders: [],
        userNames: [],
        showPhoneNumber: 'false',

        //快递
        dialog: false,
        routes: null,

        finishedStep1: false
      };
    },
    methods: {
      ...mapActions(["setLoading"]),
      dateFormat: dateFormat,
      resetForm() {
        Object.keys(this.item).forEach(f => {
          if (
            this.$refs["form." + f] !== null &&
            typeof this.$refs["form." + f] !== "undefined"
          )
            this.$refs["form." + f].resetValidation();
        });
      },
      cancel() {
        this.$router.push({name: 'tasks'});
      },

      deleteThisItem() {
        this.$confirm("确定删除?").then(
          res => {
            if (res) {
              let arr = [];
              arr.push(this.item.taskId);
              this.setLoading(true);
              axios
                .post("/tasks/delete", {
                  taskIds: arr
                })
                .then(() => {
                  this.setLoading(false);

                  this.$confirm("删除成功", {buttonFalseText: null}).then(() => {
                      this.cancel();
                    }
                  );
                })
                .catch(reason => {
                  this.$confirm(reason.response.data.message, {
                    buttonFalseText: null
                  });
                  this.setLoading(false);
                });
            }
          }
        );
      },
      deal() {
        switch (this.stepper) {
          case 1:
            this.stepper = 2;
            break;
          case 2:
            this.stepper = 3;
            break;
        }
        this.resetForm();
      },
      resetHeight() {

        let nodes;

        let int = setInterval(() => {
          nodes = document.querySelectorAll('.v-stepper__wrapper');
          if (nodes.length > 0) {
            clearInterval(int);
          }

        }, 100);


        switch (this.item.progress) {
          case this.progresses[0]:
            if(nodes)
              nodes[0].style.height = 'auto';
            break;
          case this.progresses[1]:
            this.stepper = 2;
            setTimeout(() => {
              nodes[0].style.height = 'auto';
              nodes[1].style.height = 'auto';
            }, 100);
            break;
          case this.progresses[2]:
            this.stepper = 99;
            setTimeout(() => {
              nodes[0].style.height = 'auto';
              nodes[1].style.height = 'auto';
              nodes[2].style.height = 'auto';
            }, 100);
            break;
        }


      },
      saveStep1() {
        this.validateStep1();
        if (!this.hasErrors) {
          this.setLoading(true);
          axios
            .post("/tasks", this.item)
            .then((res) => {
              this.setLoading(false);

              this.$confirm("创建成功", {buttonFalseText: null}).then(() => {
                //this.$router.back();
                this.finishedStep1 = true;
                this.item.taskId = res.data.taskId;

                //获取一下用户列表，有可能点下一步进行下去
                this.getAvailableUsers(this.item.taskId);
              });
            })
            .catch(reason => {
              this.$confirm(reason.response.data.message, {
                buttonFalseText: null
              });
              this.setLoading(false);
            });
        }
      },
      validateStep1() {
        this.hasErrors = false;
        if (
          this.$refs["form.companyId"] !== null &&
          typeof this.$refs["form.companyId"] !== "undefined"
        ) {
          if (!this.$refs["form.companyId"].validate(true)) {
            this.hasErrors = true;
          }
        }
        if (
          this.$refs["form.description"] !== null &&
          typeof this.$refs["form.description"] !== "undefined"
        ) {
          if (!this.$refs["form.description"].validate(true)) {
            this.hasErrors = true;
          }
        }
      },
      saveStep2() {
        this.validateStep2();
        if (!this.hasErrors) {
          this.item.progress = this.progresses[1];
          //新增一列
          this.item.shippingDeliveryConfirmation=false;
          if (this.showPhoneNumber === 'false') {
            delete this.item.shippingPhoneNumber;
            delete this.item.shippingProviderId;
            delete this.item.shippingNumber;
            delete this.item.shippingProviderName;
          }
          this.save();
        }
      },
      saveStep3() {
        this.validateStep2();
        if (this.hasErrors) {
          return;
        }

        //完成最后一步
        if(this.item.processingNotes){
          this.$confirm(`是否收到 ${this.item.processingNotes} ?`).then(res=>{
            if(res){
              this.item.progress = this.progresses[2];
              //this.item.shippingDeliveryConfirmation=true;

              axios
                .post(`/tasks/${this.item.taskId}/confirm-delivery`)
                .then((res) => {
                  this.save();
                })
                .catch(reason => {
                  this.$confirm(reason.response.data.message, {
                    buttonFalseText: null
                  });
                  this.setLoading(false);
                });
            }
          });
        }else{
          // this.item.progress = this.progresses[2];
          //this.item.shippingDeliveryConfirmation=false;
          this.save(true);
        }
      },

      save(isDone) {
        this.setLoading(true);
        if(isDone){
          this.item.progress = this.progresses[2];
        }

        axios
          .put("/tasks/" + this.item.taskId, this.item)
          .then((res) => {
            this.setLoading(false);

            this.$confirm("保存成功", {buttonFalseText: null}).then(() => {
              //this.$router.back();

              this.stepper = 99;
              //this.item.progress = res.data.progress;

              this.resetHeight();
            });
          })
          .catch(reason => {
            this.$confirm(reason.response.data.message, {
              buttonFalseText: null
            });
            this.setLoading(false);
          });
      },
      queryShipping() {
        //查询快递
        this.setLoading(true);
        axios
          .get("/tasks/" + this.item.taskId + "/tracking")
          .then((response) => {
            this.routes = response.data.routes;
            this.setLoading(false);
          })
          .catch(reason => {
            this.$confirm(reason.response.data.message, {
              buttonFalseText: null
            });
            this.setLoading(false);
          });
      },
      validateStep2() {
        this.hasErrors = false;

        if (
          this.$refs["form.assignedUsername"] !== null &&
          typeof this.$refs["form.assignedUsername"] !== "undefined"
        ) {
          if (!this.$refs["form.assignedUsername"].validate(true)) {
            this.hasErrors = true;
          }
        }

        if (
          this.$refs["form.createdNotes"] !== null &&
          typeof this.$refs["form.createdNotes"] !== "undefined"
        ) {
          if (!this.$refs["form.createdNotes"].validate(true)) {
            this.hasErrors = true;
          }
        }

        if (this.showPhoneNumber === 'true') {
          if (
            this.$refs["form.shippingProviderId"] !== null &&
            typeof this.$refs["form.shippingProviderId"] !== "undefined"
          ) {
            if (!this.$refs["form.shippingProviderId"].validate(true)) {
              this.hasErrors = true;
            }
          }
          if (
            this.$refs["form.shippingNumber"] !== null &&
            typeof this.$refs["form.shippingNumber"] !== "undefined"
          ) {
            if (!this.$refs["form.shippingNumber"].validate(true)) {
              this.hasErrors = true;
            }
          }
          if (
            this.$refs["form.shippingPhoneNumber"] !== null &&
            typeof this.$refs["form.shippingPhoneNumber"] !== "undefined"
          ) {
            if (!this.$refs["form.shippingPhoneNumber"].validate(true)) {
              this.hasErrors = true;
            }
          }
          if (
            this.$refs["form.processingNotes"] !== null &&
            typeof this.$refs["form.processingNotes"] !== "undefined"
          ) {
            if (!this.$refs["form.processingNotes"].validate(true)) {
              this.hasErrors = true;
            }
          }
        }
      },
      getAvailableUsers(id){
        axios
          .get(`/tasks/${id}/users`)
          .then(response => {
            this.userNames = response.data.map(c => {
              return {value: c.username, text: c.name};
            });
          })
          .catch(() => {
          });
      },
    },
    beforeDestroy(){
      window.removeEventListener('resize',this.resetHeight);
    },
    created() {
      window.addEventListener('resize',this.resetHeight);
      axios
        .get("/shipping/providers")
        .then(response => {
          this.shippingProviders = response.data.map(c => {
            return {value: c.shippingProviderId, text: c.name};
          });
        })
        .catch(() => {
        });

      //获取可选用户
      if(this.id){
        this.getAvailableUsers(this.id);
      }


      if (this.editing || this.detailing) {
        this.setLoading(true);
        axios.get("/tasks/" + this.id).then(res => {
          this.setLoading(false);
          this.item = res.data;
          this.resetHeight();
          this.showPhoneNumber = this.item.shippingNumber ? 'true' : 'false';
        })
          .catch(reason => {
            this.$confirm(reason.response.data.message, {
              buttonFalseText: null
            });
            this.setLoading(false);
          });


      } else {
        this.item = {
          description: null,
          companyId: null,
          progress: this.progresses[0],
          shippingProviderId: null,
          shippingNumber: null,
          createdNotes: null,
          shippingPhoneNumber: null,
          processingNotes:null,
        };
      }


    }
  };
</script>

<style scoped></style>
